const $ = require('jquery')
const Vue = require('vue')

Vue.component('form-numeric', {
    props: {
        label: {
            twoWay: true,
            type: String
        },
        model: {
            twoWay: true,
            default: null
        },
        compact: {
            default: false
        },
        min: {
            default: null
        },
        max: {
            default: Infinity
        }
    },
    data () {
        return {
            fieldName: null,
            workaround: true
        }
    },
    ready () {
        this.placeholder = this.placeholder || this.label
        this.fieldName = this._props.model.raw
        this.bind()
    },
    watch: {
        model () {
            this.bind()
        }
    },
    methods: {
        bind () {
            if (this.model !== null && Number.isNaN(this.model)) {
                this.model = null
            }

            this.reset();
        },
        reset () {
            this.workaround = false

            this.$nextTick(() => {
                this.build()
            })
        },
        build () {
            this.workaround = true

            this.$nextTick(() => {
                const $el = $(this.$els.input)

                if (this.model !== null) {
                    $el.val(this.model)
                }

                $el.unbind().TouchSpin({
                    min: this.min,
                    max: this.max,
                    verticalbuttons: true,
                    verticalupclass: 'glyphicon glyphicon-plus',
                    verticaldownclass: 'glyphicon glyphicon-minus'
                }).on('change', (event) => {
                    const newVal = parseInt(this.$els.input.value)
                    if (isNaN(newVal)) {
                        this.model = null
                    } else {
                        this.model = newVal
                    }
                }).on('touchspin.on.min', () => {
                    this.model = null
                    this.reset($el)
                })
            })
        },
        getHint () {
            if (this.hint) {
                return this.hint
            }
        },
        hasLabel () {
            return !!this.label || this.$hasSlot('label')
        }
    },
    template: `
        <span v-if="workaround">
            <div class="form-group" v-if="!compact">
                <form-label v-if="hasLabel()" :hint="getHint()">
                    <slot name="label">
                        {{ label }}
                    </slot>
                </form-label>
                <input v-el:input v-bind:placeholder="placeholder" v-bind:data-field="fieldName" class="form-control" />
            </div>
            <span v-if="compact">
                <input v-el:input v-bind:placeholder="placeholder" v-bind:data-field="fieldName" class="form-control" />
            </div>
        </span>
    `
})



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/form/numeric.js